'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldSet = function FieldSet(_ref) {
  var label = _ref.label,
      children = _ref.children;
  return _react2.default.createElement(
    'fieldset',
    { className: 'luna-form__fieldset' },
    label && _react2.default.createElement(
      'label',
      { className: 'luna-label' },
      _react2.default.createElement(
        'strong',
        null,
        label
      )
    ),
    children
  );
};

FieldSet.propTypes = {
  label: _propTypes2.default.string
};

exports.default = FieldSet;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/FieldSet/FieldSet.js